module.exports = __webpack_public_path__ + "media/images/gallery/constellations/auriga/aur_lines-5220971ce6397cdd09e950ef6e8d7501.gif";